<template lang="pug">
div
  p Guard will redirect to either dashboard or login
</template>

<script>

export default {
  name: 'HomePage',
};
</script>
